/** Pure helpers for lazy Canvas audio playback contract (unit-testable). */
export function resolveLazyAudioSrc(args: {
  lazyLoad: boolean
  armed: boolean
  playbackUrl: string
}): string | undefined {
  if (!args.playbackUrl) return undefined
  if (!args.lazyLoad) return args.playbackUrl
  return args.armed ? args.playbackUrl : undefined
}

export function resolveLazyAudioPreload(lazyLoad: boolean): 'none' | 'metadata' {
  return lazyLoad ? 'none' : 'metadata'
}
